import script from "./Welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./Welcome.vue?vue&type=script&setup=true&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=1e692a94&lang=scss&scoped=true"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e692a94"]])

export default __exports__